import KendoChat from '../KendoChat'
import KendoChatToolbarButton from '../KendoChat/KendoChatToolbarButton'


let KendoChatInstaller = class {
    static install(Vue) {
        Vue.component(KendoChat.name, KendoChat)
        Vue.component(KendoChatToolbarButton.name, KendoChatToolbarButton)
    }
}

export default KendoChatInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoChatInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/kendo-chat-installer/index.js